var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFilterMapMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 23 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.291 18.919c-.085.052-.187.08-.291.08s-.206-.028-.291-.08l-6.5-4.023q-.098-.061-.154-.154C1 14.649 1 14.612 1 14.543v-12.8q0-.122.073-.225a.5.5 0 0 1 .198-.16.57.57 0 0 1 .52.033L8 5.234l6.709-4.152a.555.555 0 0 1 .582 0l6.5 4.022q.098.061.154.154.055.094.055.199v12.8a.4.4 0 0 1-.073.225.5.5 0 0 1-.198.16.57.57 0 0 1-.52-.033L15 14.766zM8 5.234V19M15 14.766V1"
}))));
export default SvgFilterMapMobile;